export const APP_NAME = 'MatchRoom';
export const APP_TAGLINE = 'Watch Together. Cheer Together.';
export const APP_VERSION = '0.1.0';

export const API_PREFIX = '/api/v1';
export const SOCKET_NAMESPACE = '/';

export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

export const JWT_ACCESS_EXPIRY = '15m';
export const JWT_REFRESH_EXPIRY = '30d';

export const ROOM_INVITE_CODE_LENGTH = 8;
export const ROOM_SLUG_MAX_LENGTH = 64;

export const CHAT_MESSAGE_MAX_LENGTH = 2000;
export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 32;
export const PASSWORD_MIN_LENGTH = 8;

export const SYNC_DRIFT_THRESHOLD_MS = 500;
export const SYNC_HEARTBEAT_INTERVAL_MS = 5000;

export const REACTION_BURST_WINDOW_MS = 1000;
export const TYPING_INDICATOR_TIMEOUT_MS = 3000;

export interface IceServerConfig {
  urls: string | string[];
  username?: string;
  credential?: string;
}

export const ICE_SERVERS: IceServerConfig[] = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' },
];
